import { useFetchWrapper } from "modules/common/hooks/useFetchWrapper";
import { useQuery } from "@tanstack/react-query";
import { CardOwnershipStatusMap } from "modules/cards/model/cardStatus";
import { QUERIES } from "modules/common/query";
import { API_ROUTES } from "utils/api-route.constants";
import { useAuth } from "@clerk/nextjs";
import { USER_CONTENT_CONFIG } from "modules/common/react-query-configs";

/**
 * Returns the user's full relationship to each requested card: how many copies
 * they own (exact + alternate printings) plus which want/have lists already
 * contain it. Cache key is order-independent: same ids in any order share a
 * cache entry.
 */
export const useCardOwnershipStatus = (dataIds: string[]) => {
  const fetch = useFetchWrapper();
  const { isSignedIn } = useAuth();

  const cacheKey = [...dataIds].sort().join(",");

  const query = useQuery({
    queryKey: [QUERIES.CARD_OWNERSHIP_STATUS, cacheKey],
    queryFn: () =>
      fetch.post(API_ROUTES.MAGIC_CARDS.OWNERSHIP_STATUS, {
        dataIds,
      }) as Promise<CardOwnershipStatusMap>,
    enabled: dataIds.length > 0 && !!isSignedIn,
    ...USER_CONTENT_CONFIG,
    refetchOnMount: true,
    refetchOnReconnect: false,
  });

  return {
    query,
  };
};
